import React from "react";
import { Sparkles, Search } from "lucide-react";

export default function SmartForecastHeader({ merchantId, setMerchantId, handleSearch, loading }) {
  return (
    <header className="bg-white shadow-sm border-b border-slate-200 relative overflow-hidden pb-8 pt-10">
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob"></div>
      <div className="absolute top-0 left-0 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob animation-delay-2000"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 flex flex-col items-center text-center">
        <div className="flex items-center gap-2 mb-3">
          <Sparkles className="text-yellow-500 h-5 w-5" />
          <span className="text-purple-600 font-bold tracking-wider text-xs uppercase bg-purple-50 px-2 py-1 rounded-full border border-purple-100">
            Customer 360° & AI Analytics
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4 tracking-tight">
          Phân Tích Thông Minh
        </h1>
        <p className="text-slate-500 mb-8 max-w-xl text-lg leading-relaxed">
          Nhập Merchant ID để hệ thống phân tích tệp khách hàng, đánh giá sức khỏe cửa hàng và dự báo dòng tiền bằng AI.
        </p>

        <form onSubmit={handleSearch} className="w-full max-w-3xl space-y-4">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-purple-400 via-blue-500 to-purple-400 rounded-xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
            <div className="relative flex items-center bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden p-1">
              <Search className="ml-4 text-slate-400 h-6 w-6 flex-shrink-0" />
              <input
                type="text"
                placeholder="Nhập Merchant ID (VD: MBBMS01112660)..."
                className="w-full bg-transparent text-slate-900 placeholder-slate-400 px-4 py-4 outline-none text-lg font-medium"
                value={merchantId}
                onChange={(e) => setMerchantId(e.target.value)}
              />
              <button
                type="submit"
                disabled={loading}
                className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white px-8 py-3 rounded-lg font-semibold transition-all shadow-md whitespace-nowrap hidden sm:block"
              >
                Phân tích ngay
              </button>
            </div>
          </div>
        </form>
      </div>
    </header>
  );
}